import { render, staticRenderFns } from "./CrmUserRoles.vue?vue&type=template&id=090da3d2&scoped=true&"
import script from "./CrmUserRoles.vue?vue&type=script&lang=js&"
export * from "./CrmUserRoles.vue?vue&type=script&lang=js&"
import style0 from "./CrmUserRoles.vue?vue&type=style&index=0&id=090da3d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090da3d2",
  null
  
)

export default component.exports